import { getTableMetaHelper } from '@round/ui-kit';
import { CreatorAccountRef, ExploreAccountDetails } from '../../types';

/** One creator account to show in the table, by the handle it goes by. */
export type CreatorAccount = CreatorAccountRef & {
    /** Tells the row apart from the others in the table, which can hold the same account twice. */
    key: string | number;
    handle: string;
};

/** A creator account with what Creator Explore has on it, as the table shows it. */
export type CreatorAccountRow = CreatorAccount & ExploreAccountDetails;

export type Meta = {
    /** Whether the rows' Creator Explore accounts are still on their way, rates and stats included. */
    isExploreLoading: boolean;
    /** Whether the images of the rows' accounts are still on their way, which wait on the accounts. */
    isImagesLoading: boolean;
};

export const getMeta = getTableMetaHelper<Meta>();
